export const BACKEND_ROOT = process.env.REACT_APP_BACKEND_URL; // 'http://localhost:8080/crm'; // 'https://pro-sb.clicker.one/crm';
export const FRONTEND_ROOT = process.env.REACT_APP_FRONTEND_URL;
export const KEYCLOAK_ROOT = process.env.REACT_APP_KEYCLOAK_URL;
export const KEYCLOAK_REALM = process.env.REACT_APP_KEYCLOAK_REALM;
export const KEYCLOAK_CLIENT = process.env.REACT_APP_KEYCLOAK_CLIENT;

export const GOOGLE_ANALYTICS_API = process.env.REACT_APP_GA_MEASUREMENT_ID; // todo delete
